import { createSlice } from "@reduxjs/toolkit";
import { FiltersStateTransactionReversal } from "../filter/types";

const INITIAL_STATE: FiltersStateTransactionReversal = {
  filters: {
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const filterSlice = createSlice({
  name: "transactionReversalFilters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = {};
    },
  },
});

export const { setFilter, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;
